//#region Libraries
//#endregion
//#region Styles
import { TitleSection } from "components/styles";
import { Container } from "./styles";
//#endregion
//#region Components
import CloseButton from "components/CloseButton/CloseButton";
import DialogAlert from "components/DialogAlert/DialogAlert";
import HistoryTable from "../HistoryTable/HistoryTable";
//#endregion
//#region Images
//#endregion
//#region Services
//#endregion
//#region Utils
//#endregion

const DialogChangeHistory = ({
    dialogShow,
    changeHistory,
    resource
}) => {
    return (
        <DialogAlert 
            show={dialogShow.value} 
            toggleShow={dialogShow.toggle}
            close={() => dialogShow.toggle(false)}>
            <CloseButton onClick={() => dialogShow.toggle(false)}/>
            <Container>
                <TitleSection 
                    fontWeight="900"
                    textAlign="center">Historial de cambios - {resource.name}</TitleSection>
                <HistoryTable 
                    resourceTypeId={resource.resourceTypeId}
                    changeHistory={changeHistory}/>
            </Container>
        </DialogAlert>
    );
}

export default DialogChangeHistory;